import { setDashboardData } from "service/mapper";
import { apiGet } from "../baseApi";

export const getDataById = async (data) => {
  try {
    const response = await apiGet("_dashboard", data);
    return { ...response, data: setDashboardData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
